// import { ReactComponent as Quizz } from "../images/contenticon/quiz1.svg";
// import { ReactComponent as Settings } from "../images/contenticon/setting.svg";
// import { ReactComponent as ReviewRating } from "../images/contenticon/review&rating.svg";
// import { ReactComponent as UploadPlans } from "../images/contenticon/uploadplans.svg";
// import { ReactComponent as Notes } from "../images/contenticon/notes.svg";
// import { ReactComponent as Exam } from "../images/mastericon/Exam.svg";
// import { ReactComponent as ClientExamVector } from "../images/manageicon/clientexam.svg";
// import { ReactComponent as Batch } from "../images/manageicon/batchicon.svg";
// import { ReactComponent as LearnerIcon } from "../images/manageicon/learnericon.svg";
// import { ReactComponent as AssignExamToBatch } from "../images/manageicon/assignexamtobatch.svg";

const sidePannelData = [
  {
    id: 79,
    name: "Dashboard",
    type: "link",
    icon: "Dashboard",
    path: "/admin/dashboard",
    validity: true,
    page_status: true,
  },
  {
    id: 80,
    name: "Master",
    type: "dropdown",
    icon: "Master",
    validity: true,
    page_status: true,
    menu: [
      {
        id: 93,
        name: "Courses",
        type: "link",
        path: "/admin/courses",
        validity: true,
        page_status: true,
      },
      {
        id: 94,
        name: "Batch",
        type: "link",
        path: "/admin/batch",
        validity: true,
        page_status: true,
      },
      {
        id: 95,
        name: "Subject",
        type: "link",
        path: "/admin/subject",
        validity: true,
        page_status: true,
      },
      {
        id: 98,
        name: "Section",
        type: "link",
        path: "/admin/section",
        validity: true,
        page_status: true,
      },
       {
        id: 100,
        name: "Faculty",
        type: "link",
        path: "/admin/faculty",
        validity: true,
        page_status: true,
      },
      {
        id: 11,
        name: "Branch",
        type: "link",
        path: "/admin/center",
        validity: true,
        page_status: true,
      },
      {
        id: 15,
        name: "Center",
        type: "link",
        path: "/admin/allocatedcenter",
        validity: true,
        page_status: true,
      },
      // {
      //   id: 12,
      //   name: "Slot",
      //   type: "link",
      //   path: "/admin/slot",
      //   validity: true,
      //   page_status: true,
      // },

      {
        id: 13,
        name: "Marking System",
        type: "link",
        path: "/admin/markingsystem",
        validity: true,
        page_status: true,
      },
    ],
  },
  // {
  //   id: 81,
  //   name: "Generate Registration Link",
  //   type: "link",
  //   icon: "Exam",
  //   path: "/admin/registrationlink",
  //   validity: true,
  //   page_status: true,
  // },
  // {
  //   id: 82,
  //   name: "Allocation",
  //   icon: "Exam",
  //   type: "dropdown",
  //   validity: true,
  //   page_status: true,
  //   menu: [
  //   {
  //       id: 15,
  //       name: "Center",
  //       type: "link",
  //       path: "/admin/allocatedcenter",
  //       validity: true,
  //       page_status: true,
  //     },
  //     {
  //       id: 16,
  //       name: "Center Allocation/ReAllocation",
  //       type: "link",
  //       path: "/admin/approvedStudent",
  //       validity: true,
  //       page_status: true,
  //     },
  //     {
  //       id: 17,
  //       name: "Generate Hall Ticket",
  //       type: "link",
  //       path: "/admin/hallTicket",
  //       validity: true,
  //       page_status: true,
  //     },
  //     {
  //       id: 17,
  //       name: "Admit Card Preview",
  //       type: "link",
  //       path: "/admin/admitcard",
  //       validity: true,
  //       page_status: true,
  //     },
  //   ],
  // },
  {
    id: 83,
    name: "Learner",
    type: "dropdown",
    icon: "Learner",
    validity: true,
    page_status: true,
    menu: [
      {
        id: 96,
        name: "Add Learner",
        type: "link",
        path: "/admin/learner",
        validity: true,
        page_status: true,
      },
      {
        id: 97,
        name: "Assign Learner",
        type: "link",
        path: "/admin/assignlearner",
        validity: true,
        page_status: true,
      },
      // {
      //   id: 97,
      //   name: "Admit Card Generation",
      //   type: "link",
      //   path: "/admin/admitcard",
      //   validity: true,
      //   page_status: true,
      // },
    ],
  },
  // {
  //   id: 100,
  //   name: "Teacher",
  //   type: "dropdown",
  //   icon: "Teacher",
  //   validity: true,
  //   page_status: true,
  //   menu: [
  //     {
  //       id: 101,
  //       name: "Add Teacher",
  //       type: "link",
  //       path: "/admin/teacher",
  //       validity: true,
  //       page_status: true,
  //     },
  //     {
  //       id: 102,
  //       name: "Assign Teacher",
  //       type: "link",
  //       path: "/admin/assignteacher",
  //       validity: true,
  //       page_status: true,
  //     },
  //   ],
  // },
  // {
  //   id: 103,
  //   name: "Auth User",
  //   type: "link",
  //   icon: "AuthUser",
  //   path: "/admin/authuser",
  //   validity: true,
  //   page_status: true,
  // },
  {
    id: 84,
    name: "Feedback",
    type: "link",
    icon: "Exam",
    path: "/admin/feedback",
    validity: true,
    page_status: true,
  },
  {
    id: 84,
    name: "Exam",
    type: "link",
    icon: "Exam",
    path: "/admin/exam",
    validity: true,
    page_status: true,
  },
  {
    id: 300,
    name: "Sync Dashboard",
    type: "link",
    icon: "Dashboard",
    path: "/admin/syncdashboard",
    validity: true,
    page_status: true,
  },
  // {
  //   id: 301,
  //   name: "Centers Performance",
  //   type: "link",
  //   icon: "Dashboard",
  //   path: "/admin/centers-performance",
  //   validity: true,
  //   page_status: true,
  //   },
  {
    id: 92,
    name: "Settings",
    type: "link",
    icon: "Settings",
    path: "/admin/settings",
    validity: true,
    page_status: true,
  },
  {
    id: 99,
    name: "Reports",
    type: "link",
    icon: "ReportsIcon",
    path: "/admin/allreports",
    validity: true,
    page_status: true,
  },
  // {
  //   id: 99,
  //   name: "Reports",
  //   type: "dropdown",
  //   icon: "ReportsIcon",
  //   validity: true,
  //   page_status: true,
  //   menu: [
  //     {
  //       id: 102,
  //       name: "Attendance Report",
  //       type: "link",
  //       path: "/admin/attendancereport",
  //       validity: true,
  //       page_status: true,
  //     },
  //     {
  //       id: 100,
  //       name: "Rank Wise Report",
  //       type: "link",
  //       path: "/admin/rankwisereport",
  //       validity: true,
  //       page_status: true,
  //     },
  //     {
  //       id: 103,
  //       name: "Section Wise Report",
  //       type: "link",
  //       path: "/admin/sectionwisereport",
  //       validity: true,
  //       page_status: true,
  //     },
  //     {
  //       id: 101,
  //       name: "Response Report",
  //       type: "link",
  //       path: "/admin/responsereport",
  //       validity: true,
  //       page_status: true,
  //     },
  //     {
  //       id: 105,
  //       name: "Consolidated Report",
  //       type: "link",
  //       path: "/admin/consolidatereport",
  //       validity: true,
  //       page_status: true,
  //     },

  //     {
  //       id: 106,
  //       name: "Monthly Exam Report",
  //       type: "link",
  //       path: "/admin/montlyexamreport",
  //       validity: true,
  //       page_status: true,
  //     },
  //     {
  //       id: 107,
  //       name: "Distinct Paper Report",
  //       type: "link",
  //       path: "/admin/distinctpapercodereport",
  //       validity: true,
  //       page_status: true,
  //     },

  //     {
  //       id: 300,
  //       name: "Sync Dashboard",
  //       type: "link",
  //       path: "/admin/syncdashboard",
  //       validity: true,
  //       page_status: true,
  //     },
  //   ],
  // },

  //   {
  //     id: 91,
  //     name: "Upgrade",
  //     type: "link",
  //     icon: "UpgradeIcon",
  //     path: "/admin/upgrade",
  //     validity: true,
  //     page_status: true,
  //   },
];
export default sidePannelData;
